<template>
    <div class="index">
        <div class="content">
            <div class="public-personal-center">
                <div class="left-menu">
                    <div class="logo" :title='basicInfo.mainLogoName' @click="backIndex">
                        <img :src="basicInfo.mainLogo" alt="">
                        <span v-if="!collapsed">{{basicInfo.mainLogoName}}</span>
                    </div>
                    <a-menu
                        class="menu"
                        :default-selected-keys="['1']"
                        :default-open-keys="['sub1']"
                        mode="inline"
                        theme="dark"
                        :selected-keys="[current]"
                        @click="handleClick"
                        :inline-collapsed="collapsed"
                        >
                        <a-sub-menu key="sub1" :class="{'shrink-state':collapsed}">
                            <span slot="title">
                                <i :class="{'big-icon':collapsed,'small-icon':!collapsed}" class="iconfont icon-account-book-filled"></i>
                                <span>查找数据</span>
                            </span>
                            <a-menu-item key="1" @click="goUrl('1')">
                                <div>查公司</div>
                            </a-menu-item>
                            <a-menu-item key="2" @click="goUrl('2')">
                                <div>条件模板</div>
                            </a-menu-item>
                            <a-menu-item key="3" @click="goUrl('3')">
                                <div>高级查找</div>
                            </a-menu-item>
                            <a-menu-item key="4" @click="goUrl('4')">
                                <div>地图检索</div>
                            </a-menu-item>
                            <a-menu-item key="5" @click="goUrl('5')">
                                <div>反向查询</div>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item key="sub2" :class="{'shrink-state':collapsed}">
                            <router-link to="/LocalData">
                                <i :class="{'big-icon':collapsed,'small-icon':!collapsed}" class="iconfont icon-home-filled"></i>
                                本地数据
                            </router-link>
                        </a-menu-item>
                        <a-sub-menu key="sub3" :class="{'shrink-state':collapsed}">
                            <span slot="title">
                                <i :class="{'big-icon':collapsed,'small-icon':!collapsed}"  class="iconfont icon-account-book-filled"></i>
                                <span>操作记录</span>
                            </span>
                            <a-menu-item key="6">
                                <router-link to="/ReceivingRecord">
                                    领取记录
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="7">
                                <router-link to="/OutputRecord">
                                    导出记录
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item key="sub4" :class="{'shrink-state':collapsed}" v-if="userRole==1">
                            <router-link to="/TeamManagement">
                                <i :class="{'big-icon':collapsed,'small-icon':!collapsed}" class="iconfont icon-home-filled"></i>
                                团队管理
                            </router-link>
                        </a-menu-item>
                    </a-menu>
                </div>
                <div class="right-content">
                    <a-icon @click="toggleCollapsed(true)" v-if="!collapsed" class="stow-open" type="menu-fold" />
                    <a-icon @click="toggleCollapsed(false)" v-if="collapsed" class="stow-open" type="menu-unfold" />
                    <div class="head">
                        <LoginOut ref="child"></LoginOut>
                    </div>
                    <div class="view-content">
                        <router-view @fatherMethod="queryUserInfo" @famethod="goUrl" ref="getUrlParams"></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginOut from './../components/LoginOut' 
    export default {
        name: 'Index',
        components: { LoginOut },
        data() {
            return {
                current: '1',
                collapsed: false,
                currentParams: null,
                userRole: null,
                basicInfo: ''
            }
        },
        methods: {
            backIndex() {
                // this.$router.push({path: "/ExternalPage", query: {key: 1}})
                // this.current = 1
            },
            handleClick(e) {
                this.current = e.key;
                sessionStorage.setItem('menuKey', e.key)
            },
            toggleCollapsed(params) {
                this.collapsed = params
            },
            goUrl(params) {
                if(this.currentParams != params){
                    this.$router.push({path: "/ExternalPage", query: {key: params}})
                    this.current = params;
                    sessionStorage.setItem('menuKey', params)
                    setTimeout(()=>{
                        this.$refs.getUrlParams.getUrlParams(params)
                        
                    },50)
                    this.currentParams = params
                }
            },
            queryUserInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.userRole = response.data.data.role
                        this.$refs.child.queryUserInfo(response.data.data)
                        sessionStorage.setItem('userRole', response.data.data.role)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryBasicInfo() {
                let host = window.location.host
                this.axios(
                    {
                    method:'get',
                    url:'/api/login/loginInfo', 
                    params: {
                        hostName: host,
                    }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.basicInfo = response.data.data
                        document.title = response.data.data.sysName
                        const favicon = document.getElementById('dynamic-favicon');
                        favicon.href = response.data.data.titleLogo
                        this.$forceUpdate()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        mounted: function() {
            if(sessionStorage.getItem('menuKey')){
                this.current = sessionStorage.getItem('menuKey')
            }
            this.queryUserInfo()
            this.queryBasicInfo()
        }
    }
</script>

<style scoped lang="less">
    .index{
        height: 100%;
        .content{
            height: 100%;
        }
    }
    .public-personal-center{
        display: flex;
        width: 100%;
        height: 100%;
        background: rgba(240, 242, 243, 1);
        .left-menu{
            // width: 200px;
            height: 100%;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            z-index: 999;
            height: 100%;
            background: #001529;
            .logo{
                // display: none;
                // padding: 30px 25px;
                text-align: center;
                margin: 30px auto;
                padding-right: 12px;
                cursor: pointer;
                img{
                    width: 33px;
                    margin-left: 18px;
                }
                span{
                    color: rgba(58, 255, 255, 1);
                    font-size: 18px;
                    margin-left: 8px;
                    float: right;
                    padding-top: 2px;
                }
            }
            .shrink-state{
                margin-bottom: 25px;
            }
            .big-icon{
                font-size: 24px;
                margin-right: 30px;
            }
            .small-icon{
                margin-right: 7px;
            }
        }
        .right-content{
            flex: 1;
            height: 100%;
            width: 100%;
            position: relative;
            .stow-open{
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                cursor: pointer;
                position: absolute;
                z-index: 1000;
                top: 20px;
                left: 16px;
            }
            .head{
                height: 50px;
                padding: 0px 16px;
                background:#fff;
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
                position: absolute;
                left: 0;
                top: 0;
                z-index: 100;
                width: 100%;
            }
            .view-content{
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                overflow: auto;
                padding-top: 50px;
            }
        }
    }
</style>
